module.exports = __webpack_public_path__ + "static/media/logoSquare.0d616750.png";